import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "The sad state of BlackBerry apps",
  "description": "",
  "published": "2010-04-19T00:00:00.000Z",
  "redirect_from": ["/blog/the-sad-state-of-blackberry-apps/swizec/1309"],
  "categories": "BlackBerry, food for thought, Handhelds, life, RunKeeper, Smartphone, SportyPal, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.crunchbase.com/product/iphone"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/04/19797v1-max-250x250.jpg",
              "alt": "Image representing iPhone as depicted in Crunc...",
              "title": "Image representing iPhone as depicted in Crunc..."
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://www.crunchbase.com"
          }}>{`CrunchBase`}</a></p>
      </li>
    </ul>
    <p>{`This morning just as I was battling with the question of going for a morning run or not I came across this facebook status`}</p>
    <blockquote>
      <p parentName="blockquote">{`<`}{`a status I am currently unable to find>`}</p>
    </blockquote>
    <p>{`But anyway, it was of something called @runkeeper and a dude reported he just ran 0.00 kilometers.`}</p>
    <p>{`So why would this matter?`}</p>
    <p>{`Because it gave me the idea that hey, if I tracked my runs I could get empirical data on what I'm doing and being the geek that I am this would inspire me to run more, harder and oftener.`}</p>
    <p>{`Yayz! `}{`\\`}{`o/`}</p>
    <p>{`Then I went looking for this `}<a parentName="p" {...{
        "href": "http://runkeeper.com/",
        "title": "RunKeeper"
      }}>{`RunKeeper`}</a>{` app ... well whaddya know, it only exists for `}<a parentName="p" {...{
        "href": "http://www.apple.com/iphone",
        "title": "iPhone"
      }}>{`iPhones`}</a>{`, who cares about you dirty `}<a parentName="p" {...{
        "href": "http://www.blackberry.com",
        "title": "BlackBerry"
      }}>{`BlackBerry`}</a>{` users. You all suck anyway, you never do cool things! (gee I wonder why)`}</p>
    <p>{`Well, after minutes upon minutes upon minutes upon dirty minutes of looking for something I finally came across an app that supports blackberries in the seedy underbelly of the internet's shady alleys where drug dealing pederast's push their wares.`}</p>
    <p>{`It is called SportyPal.`}</p>
    <p>{`Hoorah!`}</p>
    <p>{`I downloaded it, fired it up and went for my run. After half an hour I come back home, look at the app and ... why the flying shit is this? The stupid thing didn't even manage to start getting GPS data during this time. Yep, 30 minutes of running and it didn't even `}<em parentName="p">{`begin`}</em>{` tracking anything.`}</p>
    <p>{`Then two minutes later it failed with a "I'm sorry"`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/740d9278-a559-4fb4-9cca-c2da19eeb5b1/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=740d9278-a559-4fb4-9cca-c2da19eeb5b1",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      